import React, { createContext, useContext, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

import { KeyValue } from "@/main/models/common";

interface IUsergroupRegisterContext {
	isEdit: boolean;
	setIsEdit: (value: boolean) => void;
}

interface IUsergroupRegisterProvider {
	children: React.ReactNode;
}

// Interface to react-hook-form
const INITIAL_FORM_STATE = {
	country: null as KeyValue | null,
	companyType: null as KeyValue | null,
	company: null as KeyValue | null,
	userGroup: "",
	status: null as KeyValue | null,
	systemApplication: null as KeyValue | null,
};

export type IUsergroupRegisterForm = typeof INITIAL_FORM_STATE;

const UsergroupRegisterContext = createContext<IUsergroupRegisterContext>({
	isEdit: false,
	setIsEdit: () => {},
});

function UsergroupRegisterProvider({ children }: IUsergroupRegisterProvider) {
	const methods = useForm<IUsergroupRegisterForm>({
		mode: "onChange",
		defaultValues: INITIAL_FORM_STATE,
	});

	const [isEdit, setIsEdit] = useState(false);

	return (
		<FormProvider {...methods}>
			<UsergroupRegisterContext.Provider
				value={{
					isEdit,
					setIsEdit,
				}}
			>
				{children}
			</UsergroupRegisterContext.Provider>
		</FormProvider>
	);
}

const useUsergroupRegisterContext = () => useContext(UsergroupRegisterContext);

export { UsergroupRegisterProvider, useUsergroupRegisterContext };
